import { PickupAvailability } from '@/scripts/optional/pickup-availability'
import { PickupAvailabilityDrawer } from '@/scripts/optional/pickup-availability-drawer'
import { TsDOM as q} from '@/scripts/core/TsDOM'
q.safeDefineElement(PickupAvailabilityDrawer)
q.safeDefineElement(PickupAvailability)

